const handlePopup = () => {
    const selectors = {
        popup: '.js-popup',
        content: '.js-popup-content',
        closeBtn: '.js-popup-close',
    };

    const classes = {
        active: 'is-active'
    };

    const popup = document.querySelector(selectors.popup);
    const content = document.querySelector(selectors.content);
    const closeBtn = document.querySelector(selectors.closeBtn);

    if(popup && content && closeBtn)
    popup.addEventListener('click', event => {
        if(!content.contains(event.target) || closeBtn.contains(event.target))
          popup.classList.remove(classes.active);
    });
}

export default handlePopup;